<div mat-pagination-wrapper dir="ltr">
	<button
		aria-label="Go to the first page."
		*ngIf="showFirstLastButtons"
		mat-button
		[matTooltip]="translations?.SHARED?.ACTIONS?.FIRST_PAGE || 'First page'"
		(click)="goToPage(1)"
		[disabled]="!hasPages || isFirstPage || disabled">
		<mat-icon [svgIcon]="!hasPages || isFirstPage || disabled ? 'first_page_disabled' : 'first_page'"></mat-icon>
	</button>
	<button
		aria-label="Go to the previous page."
		mat-button
		[matTooltip]="translations?.SHARED?.ACTIONS?.PREV_PAGE || 'Previous page'"
		(click)="back()"
		[disabled]="!hasPages || isFirstPage || disabled">
		<mat-icon [svgIcon]="!hasPages || isFirstPage || disabled ? 'chevron_left_disabled' : 'chevron_left'"></mat-icon>
	</button>
	<mat-form-field>
		<input
			aria-label="Enter page number to go to."
			matInput
			(blur)="onInputBlur($event)"
			[min]="1"
			[max]="totalPages"
			autocomplete="off"
			type="number"
			[ngModelOptions]="{ updateOn: 'blur' }"
			[(ngModel)]="currentPage"
			[disabled]="!hasPages || disabled" />
		<span matSuffix>{{ translations?.SHARED?.OF || 'of' }} {{ totalPages }}</span>
	</mat-form-field>
	<button
		aria-label="Go to the next page."
		mat-button
		[matTooltip]="translations?.SHARED?.ACTIONS?.NEXT_PAGE || 'Next page'"
		(click)="next()"
		[disabled]="!hasPages || isLastPage || disabled">
		<mat-icon [svgIcon]="!hasPages || isLastPage || disabled ? 'chevron_right_disabled' : 'chevron_right'"></mat-icon>
	</button>
	<button
		aria-label="Go to the last page."
		*ngIf="showFirstLastButtons"
		mat-button
		[matTooltip]="translations?.SHARED?.ACTIONS?.LAST_PAGE || 'Last page'"
		(click)="goToPage(totalPages)"
		[disabled]="!hasPages || isLastPage || disabled">
		<mat-icon [svgIcon]="!hasPages || isLastPage || disabled ? 'last_page_disabled' : 'last_page'"></mat-icon>
	</button>
</div>
